import React from "react";
import useFetch from "@/lib/useFetch";
import { GlassCard, PageTitle, StatusBadge, EmptyState, MetricCard } from "@/components/lux";
import { money } from "@/lib/api";
import { Users } from "lucide-react";

export default function Directs() {
  const { data, loading } = useFetch("/user/directs");
  return (
    <div className="space-y-6">
      <PageTitle title="My Directs" subtitle="Members you personally referred" />
      <MetricCard label="Direct Referrals" value={data?.count ?? "—"} icon={Users} accent className="max-w-xs" />
      <GlassCard className="p-6">
        {loading ? <div className="skeleton h-40" /> : data?.directs?.length ? (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="text-left text-[var(--text-dim)]"><tr className="border-b border-white/10">
                <th className="py-3">Member ID</th><th className="py-3">Name</th><th className="py-3">Side</th><th className="py-3">Package</th><th className="py-3">Rank</th><th className="py-3">Status</th><th className="py-3">Joined</th></tr></thead>
              <tbody>
                {data.directs.map((d) => (
                  <tr key={d.member_id} className="row-hover border-b border-white/5">
                    <td className="py-3 text-white">{d.member_id}</td><td className="py-3">{d.name}</td>
                    <td className="py-3 capitalize">{d.position}</td><td className="py-3 gold-text">${money(d.package)}</td>
                    <td className="py-3">{d.rank}</td><td className="py-3"><StatusBadge status={d.status} /></td>
                    <td className="py-3 text-[var(--text-dim)]">{(d.created_at || "").slice(0, 10)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : <EmptyState icon={Users} title="No direct referrals yet" hint="Share your Member ID as a sponsor to grow your team." />}
      </GlassCard>
    </div>
  );
}
